// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ToastCloseButton = ({ closeToast }: any) => (
  <i className="flex items-center gap-[5px] mr-[5px]" onClick={closeToast}>
    <img src="/icons/toast/Divisor.svg" alt="close button" />
    <img src="/icons/toast/Close.svg" alt="close button" />
  </i>
);
